export default function(value?: number): string {
	if (typeof value !== 'number') {
		return '';
	}
	if (value <= 0) {
		return '';
	}
	if (value <= 10) {
		return '10';
	}
	return (Math.round(value / 10) * 10).toString();
}
